import type { FaireProductEntity } from "../../entity_types/product";

export const p_daxsgsypr7: FaireProductEntity = {
  token: "p_daxsgsypr7",
  type: "product",
  name: "18K Gold Non-Tarnish Stackable Rings",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/53577873d1d17c6b5d11f7c929d860d19ffa6fd24df0ac9e1de790806a4801e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90e4cc6c2fb3546a722c9eeec84c0c6657db906cb5edd430e00ad5f9fccb530a.jpeg",
    "https://cdn.faire.com/fastly/f29012282c3bcc8a885a54da98486a2f538f36db1d36b7621e002c0c60e9de2f.jpeg",
    "https://cdn.faire.com/fastly/ddd9c71d612ed6a041e51aeccc3c5ec87f39b1531cf088b6fe45fa93cd269b25.jpeg",
    "https://cdn.faire.com/fastly/fd5353134c393950603514342f251b45e3b1924d679a282aedd8cdb31409d1f9.jpeg",
    "https://cdn.faire.com/fastly/96c02ad129ca7cd3fb9f3b7b8bf8e2f69c17063a8aa939b17a6064abc085a00a.jpeg",
  ],
  priceDollars: 9.64,
  description:
    "*** Pieces sold separately \nAMORIA 18K Gold Non-Tarnish Crystal Pave Ring\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\n\nBELLINE 18K Gold Non-Tarnish Teardrop CZ Ring\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\n\nBRISELLE 18K Gold Non-Tarnish Smooth Wave Ring\n18K Gold Plating\nStainless Steel\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:19.308Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
